// Shared helpers for multi-step service application forms.

export const getFormStorageKey = (serviceId) => `consultium:serviceForm:${serviceId}`;

export const loadSavedForm = (serviceId) => {
  try {
    const raw = localStorage.getItem(getFormStorageKey(serviceId));
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    console.warn('[formUtils] loadSavedForm failed', err);
    return null;
  }
};

export const saveForm = (serviceId, data) => {
  try {
    localStorage.setItem(getFormStorageKey(serviceId), JSON.stringify(data));
  } catch (err) {
    // Most often a QuotaExceededError — non-fatal, the user just won't get autosave.
    console.warn('[formUtils] saveForm failed', err);
  }
};

export const clearSavedForm = (serviceId) => {
  try {
    localStorage.removeItem(getFormStorageKey(serviceId));
  } catch (err) {
    console.warn('[formUtils] clearSavedForm failed', err);
  }
};

// Map from service.id => form component name (loaded in ServiceForm.jsx)
// Services not listed fall back to GenericServiceForm.
export const FORM_TYPE_BY_SERVICE = {
  'company-registration': 'company-registration',
  'tax-clearance': 'tax-clearance',
  'director-changes': 'director-changes',
  'annual-returns': 'annual-returns',
  'beneficial-ownership': 'beneficial-ownership',
  'public-officer': 'public-officer',
};
